import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpMiniCartComponent} from './dcp-mini-cart.component';
import {ConfigModule, DeferLoadingStrategy, I18nModule, UrlModule} from '@spartacus/core';
import {RouterModule} from '@angular/router';


@NgModule({
  declarations: [DcpMiniCartComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MiniCartComponent: {
          component: DcpMiniCartComponent,
          deferLoading: DeferLoadingStrategy.INSTANT
        }
      }
    }),
    RouterModule,
    UrlModule,
    I18nModule,
  ]
})
export class DcpMiniCartModule {
}
